import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "iodine-padding-bottom-md iodine-padding-top-md"
}

import ResearchItemsContainer from 'components/resources/ResearchSectionContainer.vue';
  import { useResourcesStore } from 'stores/resources-store';

export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchPane',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!

  return (_openBlock(), _createBlock(_component_q_scroll_area, { class: "research-scroll-area" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useResourcesStore)().getResourcesResearches('D69.9'), (section, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: section.code
        }, [
          (index !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_q_separator)
              ]))
            : _createCommentVNode("", true),
          _createVNode(ResearchItemsContainer, { "research-section-data-model": section }, null, 8, ["research-section-data-model"])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})